// "use client";

// import { useTranslation } from "@/app/i18n/client";
// import { fallbackLng } from "@/app/i18n/settings";
import Link from "next/link";

interface LocaleLinkProps {
    href: string;
    children: React.ReactNode;
    [key: string]: any;
}

export default function LocaleLink({ href, ...props }: LocaleLinkProps) {
    // const { lang } = useTranslation();

    // const isDefaultLang = lang === fallbackLng;
    // const path = isDefaultLang ? href : `/${lang}${href}`;
    return <Link href={href} {...props} />;
}
